import * as React from "react";

function SvgSearchFilled(props) {
  return <svg viewBox="0 0 43 44" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17 0C7.602 0 0 7.602 0 17s7.602 17 17 17c3.355 0 6.46-.984 9.094-2.656l12.281 12.281 4.25-4.25L30.5 27.281C32.68 24.421 34 20.88 34 17c0-9.398-7.602-17-17-17zm0 4c7.2 0 13 5.8 13 13s-5.8 13-13 13S4 24.2 4 17 9.8 4 17 4z" /></svg>;
}

export default SvgSearchFilled;